import './Label.css'

const Label = ({yScale, callData}) => {
    const {id, name, duration} = callData;

    return (
        <g
            key={`text-${id}`}
            fill="black"
            transform={`translate(0,${yScale(id) + yScale.bandwidth() / 2})`}
            className="callLabel"
            textAnchor="end"
        >
            <text
                dy="0.35em"
            >
                {name}
            </text>
            <text
                dy="0.35em"
                className="classLabel_latency"
                transform={`translate(0, 15)`}
            >
                {duration}ms
            </text>
        </g>
    )
}

export default Label
